/* eslint-disable react-hooks/exhaustive-deps */
import {
  DownOutlined,
  LoadingOutlined,
  PlusOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Col,
  Descriptions,
  Dropdown,
  Form,
  Grid,
  Input,
  Result,
  Row,
  Space,
  Spin,
  Switch,
  Tooltip,
  Typography,
  Upload,
  message
} from 'antd';
import lodashClonedeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import 'react-credit-cards/es/styles-compiled.css';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {
  Label,
  SubSubtitle,
  SubSubtitleStart,
  Subtitle,
  Title,
  TitleBar
} from '../../components';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SolicitudPlanVigencia from '../../components/SolicitudPlanVigencia';
import StepperSolicitud from '../../components/StepperSolicitud';
import {
  CONFIG,
  ESTADOS,
  NACIONALIDADES,
  USER_STATES,
  compressionOptions
} from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import SessionContext from '../../context/session-context';
import { useSolicitudContext } from '../../context/solicitud-context';
import UserContext from '../../context/user-context';
import { isEmpty, validateCedulaIdentidad } from '../../functions/images';
import {
  consultarCliente,
  errorHandler,
  formatCelular,
  getCarouselData,
  getTable,
  heicAndheifConvert,
  myImageCompression,
  parseCelular,
  relaciones,
  relacionesAsegurados,
  transformarPropiedades
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import { redondear } from '../../utils/converters';
import BotonSiguiente from '../BotonSiguiente';
import '../Form.css';
import AseguradosList from '../personal/AseguradosList';
import BeneficiariosList from '../personal/BeneficiariosList';
import ContactoHogar from './ContactoHogar';
import DescripcionesHogar from './DescripcionesHogar';

const { useBreakpoint } = Grid;
const colStyles = {
  display: 'table',
  textAlign: 'center',
  justifyContent: 'center'
};
const maxWidth = 1096;

// lila #393182
// rojo #D8605D
// verde #8CEFD5
// amarillo #FBEB77
// gris #F3F4F3

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file, setLoading) {
  setLoading(true);
  const isJpgOrPng =
    file.type === 'image/jpeg' ||
    file.type === 'image/heif' ||
    file.type === 'image/heic' ||
    file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('El formato del archivo no está permitido.');
  }
  const isLt10M =
    file.size /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 /
      1024 <
    2;
  if (!isLt10M) {
    message.error('El tamaño de la imagen debe ser inferior a 10MB.');
  }
  setLoading(false);
  return isJpgOrPng && isLt10M;
}

const stepsHogar = () => [
  {
    name: 'plan',
    description: (
      <span>
        Elegí tu <strong>Plan</strong>
      </span>
    )
  },
  {
    name: 'fotos',
    description: (
      <span>
        Subí las fotos de la Cédula de Identidad del{' '}
        <strong>Asegurado Titular</strong>
      </span>
    )
  },
  {
    name: 'asegurados',
    description: (
      <span>
        Confirmá los datos del <strong>Asegurado Titular</strong>
      </span>
    )
  },
  {
    name: 'beneficiarios',
    description: (
      <span>
        Confirmá los datos de los{' '}
        <strong>Beneficiarios del Asegurado Titular</strong>
      </span>
    )
  },
  {
    name: 'contacto',
    description: (
      <span>
        Confirmá los datos del <strong>Inmueble</strong>
      </span>
    )
  },
  {
    name: 'confirmar',
    description: (
      <span>
        ¡Confirmá tu <strong>Solicitud</strong>!
      </span>
    )
  }
];

const stepsComercio = [
  {
    name: 'plan',
    description: (
      <span>
        Confirmá tu <strong>Plan</strong>
      </span>
    )
  },
  {
    name: 'fotos',
    description: (
      <span>
        Subí las fotos de la Cédula de Identidad del{' '}
        <strong>Asegurado Titular / Representante Legal</strong>
      </span>
    )
  },
  {
    name: 'contacto',
    description: (
      <span>
        Confirmá los datos del{' '}
        <strong>Asegurado Titular / Representante Legal</strong>
      </span>
    )
  },
  {
    name: 'confirmar',
    description: (
      <span>
        ¡Confirmá tu <strong>Solicitud</strong>!
      </span>
    )
  }
];

const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const FormNew = ({
  cotizaciones,
  token,
  isMasiva,
  loading: loadingPlanes,
  loaded: loadedPlanes,
  onDebounce,
  debouncing
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { user, userState } = useContext(UserContext);
  const myRef = useRef(null);
  const scrollTop = () => scrollToRef(myRef);
  const [principalLoading, setPrincipalLoading] = useState(false);
  const [solicitado, setSolicitado] = useState(false);
  const { producto, empresa, empresaProducto } = useContext(EmpresaContext);
  const [productoCotizacion, setProductoCotizacion] = useState({});

  const { incluye_conyuge, incluye_hijos } = productoCotizacion;
  const [esJuridica, setEsJuridica] = useState(false);
  const [soloNumCedula, setSoloNumCedula] = useState(false);
  const [cedulaManualForm] = Form.useForm();
  const noEsCliente = user && user['cognito:groups'][0] !== 'CLIENTE';

  let steps =
    productoCotizacion.codigo === 4
      ? stepsHogar(esJuridica, empresaProducto.beneficiarios)
      : stepsComercio;
  let incluyeOtros = false;
  if (incluye_conyuge || incluye_hijos) {
    incluyeOtros = true;
  }
  const [selectedCotizacion, setSelectedCotizacion] = useState();
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedPlanTipo, setSelectedPlanTipo] = useState();
  const [beneficiarios, setBeneficiarios] = useState({});
  const [datosEncontrados, setDatosEncontrados] = useState({});
  const [
    datosEncontradoEmpresaJuridica,
    setDatosEncontradosEmpresaJuridica
  ] = useState({});
  const [asegurados, setAsegurados] = useState({});
  const [datosContacto, setDatosContacto] = useState({});
  const [datosContactoFromCIA, setDatosContactoFromCIA] = useState({});
  const [datosContactoFromCID, setDatosContactoFromCID] = useState({});
  const [datosExternosPersona, setDatosExternosPersona] = useState({});
  const [
    cotizacionActividadDetalles,
    setCotizacionActividadDetalles
  ] = useState([]);
  const [cotizacionActividades, setCotizacionActividades] = useState([]);
  const [
    datosExternosPersonaImagenCID,
    setDatosExternosPersonaImagenCID
  ] = useState({});
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [current, setCurrent] = useState(0);
  const [cedula1, setCedula1] = useState(''); // file upload
  const [cedula2, setCedula2] = useState(''); // file upload
  const [isDirty, setIsDirty] = useState(true);
  const [loadingBefore, setLoadingBefore] = useState(false);
  const screens = useBreakpoint();
  const marginLeftPrincipal = screens && screens.md === true && 50;
  const marginRightPrincipal = screens && screens.md === true && 10;
  const maxWidthHoja =
    screens &&
    screens.md === true &&
    maxWidth + marginLeftPrincipal + marginRightPrincipal;

  const { collapsed } = useContext(SessionContext);
  let marginLeft = 0;
  if (collapsed !== undefined && screens.md === true) {
    marginLeft = collapsed ? 80 / 2 : 300 / 2;
  }
  const founddatosBCP = {};
  const datosImg = {};
  const {
    solicitarRequest,
    smsEnviado,
    setDatosOriginales,
    datosOriginales,
    setDatosBCP,
    datosBCP,
    calendarioPagosContext,
    vigenciaPagosContext
  } = useSolicitudContext();
  const [monedas, setMonedas] = useState();
  const [moneda, setMoneda] = useState();
  const [coincideCI, setCoincideCI] = useState();
  const [selectedMonedaPlan, setSelectedMonedaPlan] = useState();
  const [vigenciaSugeridaConfig, setVigenciaSugeridaConfig] = useState();
  const [loadingVigenciaSugerida, setLoadingVigenciaSugerida] = useState(false);
  const [vigenciaByAseguradoraList, setVigenciaByAseguradoraList] = useState([
    {
      aseguradora: null,
      config: null,
      vigencia: {
        desde: null,
        hasta: null,
        cantidad_dias: null
      },
      pagos: {
        cantidad_pagos: null,
        frecuencia: null
      }
    }
  ]);
  const [impresion, setImpresion] = useState(false);
  const [construccionData, setConstruccionData] = useState();

  const [fields, setFields] = useState({
    marca: null,
    modelo: null,
    submodelo: null,
    anio: null,
    monto: 0,
    chassis: null,
    chapa: null,
    color: undefined,
    otroColor: undefined,
    origen: null,
    uso: 'PARTICULAR',

    nombres: null,
    prefix: '+595',
    celular: null,
    cedula: null,
    cedulaOrRuc: null,
    correo: null,
    sexo: undefined,
    lugarNacimiento: null,
    fechaNacimiento: null,
    domicilio: null,
    departamento: undefined,
    distrito: undefined,
    nacionalidad: undefined,
    estadoCivil: undefined,
    departamentoInmueble: undefined,
    distritoInmueble: undefined,

    ruc: null,
    profesion: null,
    ingresos: null,
    proveedoEstado: false,
    politicamenteExpuesto: false,
    trabajo: undefined,
    institucion: undefined,
    cargo: null,
    anioIngreso: null,
    empresaEmpleador: null,
    rucEmpleador: null,
    telefonoEmpleador: null,
    celularEmpleador: null,
    direccionEmpleador: null,

    formaPago: null,
    metodoPago: null,
    titularTarjeta: null,
    numeroTarjeta: null,
    vencimientoTarjeta: null,
    isValid: null,
    issuer: null,
    maxLength: null,
    mesVencimiento: null,
    anhoVencimiento: null,

    numeroCuenta: null
  });

  const formatosImagen = 'image/jpeg,image/heif,image/heic,image/png';

  const getIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return 2000000;
      case '2':
        return 6000000;
      case '3':
        return 11000000;
      case '4':
        return 16000000;
      default:
        return 0;
    }
  };

  const getSelectedPlan = () => {
    return cotizaciones
      .find((item) => item.id === selectedCotizacion)
      .planes.filter(
        ({ id_plan, id_moneda }) =>
          ((id_plan && selectedPlanTipo === 'estandar') ||
            (!id_plan && selectedPlanTipo === 'especifico')) &&
          id_moneda === selectedMonedaPlan.id
      )[selectedPlan];
  };

  const getCotizacionActividadDetalles = async () => {
    try {
      const response = await instanceRef.instance.get(
        `/actividaddetalle/cotizacion/${token}`
      );
      const list = response.data.data;
      setCotizacionActividadDetalles(
        list.map((e) => ({
          value: e.actividadDetalle.id,
          label: e.actividadDetalle.detalle
        }))
      );
      return list;
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  const getCotizacionActividades = async () => {
    try {
      const response = await instanceRef.instance.get(
        `/actividad/cotizacion/${token}`
      );
      const list = response.data.data;
      setCotizacionActividades(
        list.map((e) => ({
          value: e.actividad.id,
          label: e.actividad.grupo
        }))
      );
      return list;
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  const solicitar = async (type) => {
    setPrincipalLoading(true);
    const cotizacion = cotizaciones.find(
      (item) => item.id === selectedCotizacion
    );
    const {
      id: plan,
      monto_total,
      monto_total_conyuge,
      monto_total_hijos
    } = getSelectedPlan();

    const conyuges = asegurados?.list?.filter(
      (item) => item.tipo === 'conyuge'
    );
    const hijos = asegurados?.list?.filter((item) => item.tipo === 'hijo');
    const cantidadConyuges = conyuges ? conyuges.length : 0;
    const cantidadHijos = hijos ? hijos.length : 0;
    /*
    const listaVigenciaPago = cotizaciones
      .find((item) => item.id === selectedCotizacion)
      .aseguradoraEmpresaProducto.empresaProductoVigencia.map(
        ({ vigenciaPago }) => vigenciaPago
      );
 */
    const {
      metodoPago,
      // modalidadPago,
      vigenciaPago,
      numeroTarjeta,
      titularTarjeta,
      vencimientoTarjeta,
      numeroCuenta,
      respuestas,
      issuer,
      tercero,
      endoso,
      empresaJuridica,
      vinculo,
      entidad,
      periodo,
      ...remaining
    } = datosContacto;

    const vigenciaPagosForm = vigenciaPagosContext; /* vigenciaByAseguradoraList.find((item) => {
      const aseguradora = getSelectedAseguradora();
      return item.aseguradora.id === aseguradora.id;
    }); */
    const modalidadPago = vigenciaPagosForm.pagos?.frecuencia?.id;

    /*  const multiplicador = listaVigenciaPago.find(
      (item) => item.id === vigenciaPago
    )?.multiplicador;

    const montoTotal =
      redondear(Number(monto_total) * multiplicador) +
      redondear(Number(monto_total_conyuge) * multiplicador) *
        cantidadConyuges +
      redondear(Number(monto_total_hijos) * multiplicador) * cantidadHijos;
*/
    const montoTotal = calendarioPagosContext.reduce(
      (total, pago) => total + pago.monto,
      0
    );
    const cotizacionNew = {
      ...cotizacion,
      ...(isMasiva &&
        producto === 4 && { cotizacionMasivaPersona: cotizacion.persona }),
      endoso: datosContacto.endoso,
      persona: {
        ...(!isMasiva && producto !== 4 && { ...cotizacion.persona }),
        ...datosEncontrados,
        ...remaining,
        cedula: remaining.cedula,
        nombres: remaining.nombres,
        correo: remaining.correo,
        domicilio: remaining.domicilio,
        id_departamento: remaining.departamento,
        id_distrito: remaining.distrito,
        nacionalidad: remaining.nacionalidad,
        sexo: remaining.sexo,
        estado_civil: remaining.estadoCivil,
        lugar_nacimiento: remaining.lugarNacimiento,
        // eslint-disable-next-line no-nested-ternary
        fecha_nacimiento: remaining.fechaNacimiento
          ? moment.isMoment(remaining.fechaNacimiento)
            ? remaining.fechaNacimiento.format('DD/MM/YYYY')
            : remaining.fechaNacimiento
          : '',
        celular: `${fields.prefix}${formatCelular(remaining.celular)}`,
        ruc: remaining.ruc,
        profesion: remaining.profesion,
        ingresos: getIngreso(remaining.ingresos),
        proveedor_estado: remaining.proveedorEstado ? 'Sí' : 'No',
        expuesta_politicamente: remaining.politicamenteExpuesto ? 'Sí' : 'No',
        vinculo,
        entidad,
        periodo,
        tipo_empleado: remaining.trabajo,
        institucion_publica: remaining.institucion,
        institucion_cargo: remaining.cargo,
        institucion_anhoingreso: remaining.anioIngreso,
        empleador_ruc: remaining.rucEmpleador || 'A Confirmar',
        empleador_empresa: remaining.empresaEmpleador,
        empleador_telefono: remaining.telefonoEmpleador || 'A Confirmar',
        empleador_celular: remaining.celularEmpleador
          ? `${fields.prefix}${formatCelular(remaining.celularEmpleador)}`
          : 'A Confirmar',
        empleador_direccion: remaining.direccionEmpleador,
        juridica: esJuridica,
        latitud: remaining.coordenadasAsegurado?.latitud,
        longitud: remaining.coordenadasAsegurado?.longitud,
        personaBCP: remaining.personaBCP,
        datos_externos: {
          ...datosExternosPersona,
          imagen: {
            ...datosExternosPersona.imagen,
            ...datosExternosPersonaImagenCID
          }
        }
      },
      rucJuridicaBCP: remaining.rucJuridicaBCP,
      rubro: remaining.rubro,
      tipo_establecimiento: remaining.tipo_establecimiento,
      isMasiva
    };

    const inmueble = {
      id: cotizacion.id_inmueble,
      domicilio: remaining.domicilioInmueble,
      id_departamento: remaining.departamentoInmueble,
      id_distrito: remaining.distritoInmueble,
      cuenta: remaining.cuentaInmueble,
      latitud: remaining.coordenadasInmueble?.latitud,
      longitud: remaining.coordenadasInmueble?.longitud,
      cantidad_niveles: construccionData && construccionData.cantidadNiveles
    };

    const filesToSend = [];
    if (cedula1) {
      filesToSend.push(cedula1);
    }
    if (cedula2) {
      filesToSend.push(cedula2);
    }

    try {
      if (respuestas) {
        const keys = Object.keys(respuestas);
        for (const key of keys) {
          if (
            productoCotizacion.codigo === 5 &&
            key !== 'pregunta1' &&
            key !== 'pregunta8'
          ) {
            respuestas[key] = respuestas[key] ? respuestas[key] : 'No';
          }
          if (productoCotizacion.codigo === 4 && key === 'pregunta1') {
            respuestas[key] = respuestas[key] ? respuestas[key] : 'No';
          }
        }
      }
    } catch (error) {
      // error
    }

    const solicitud = {
      formaPago: fields.formaPago,
      numeroTarjeta: '',
      titularTarjeta: '',
      vencimientoTarjeta: '',
      marcaTarjeta: '',
      numeroCuenta: '',
      cotizacion: cotizacionNew,
      respuestas,
      plan,
      idMetodoPago: metodoPago,
      idModalidadPago: modalidadPago,
      idVigenciaPago: vigenciaPago,
      asegurados:
        asegurados?.list?.length > 0
          ? asegurados.list.map((item, orden) => ({
              ...item,
              // eslint-disable-next-line no-nested-ternary
              fecha_nacimiento: item.fechaNacimiento
                ? moment.isMoment(item.fechaNacimiento)
                  ? item.fechaNacimiento.format('DD/MM/YYYY')
                  : item.fechaNacimiento
                : '',
              orden: orden + 1
            }))
          : [],
      beneficiarios:
        beneficiarios?.list?.length > 0 && beneficiarios?.list[0].nombres
          ? beneficiarios.list.map((item, orden) => ({
              ...item,
              orden: orden + 1,
              relacion:
                item.relacion === 'otro' ? item.relacionOtro : item.relacion
            }))
          : [],

      files: filesToSend,
      montoTotal,
      montoTotalConyuge:
        redondear(Number(monto_total_conyuge)) * cantidadConyuges,
      montoTotalHijos: redondear(Number(monto_total_hijos)) * cantidadHijos,
      montoTotalTitular: Number(monto_total),
      inmueble,
      tercero: {
        ...tercero,
        celular: tercero.celular
          ? `${fields.prefix}${formatCelular(tercero.celular)}`
          : null
      },
      empresaJuridica: esJuridica
        ? {
            ...datosEncontradoEmpresaJuridica,
            ...empresaJuridica,
            id_persona: cotizacionNew.persona.id,
            rucJuridicaBCP: cotizacionNew.rucJuridicaBCP
          }
        : undefined,
      vigencia: {
        fechaInicioVigencia: vigenciaPagosForm.desde,
        fechaFinVigencia: vigenciaPagosForm.hasta,
        cantidadDias: vigenciaPagosForm.cantidad_dias
      },
      numeroCuotas: vigenciaPagosForm?.pagos?.cantidad_pagos,
      pagos: {
        list: calendarioPagosContext,
        numeroCuotas: vigenciaPagosForm?.pagos?.cantidad_pagos
      },
      poliza_impresion: impresion,
      construccion: construccionData
      // politicamenteExpuesto:
      // vinculo:
      // entidad:
      // periodo_desde:
      // periodo_hasta:
    };

    try {
      await solicitarRequest(solicitud, empresa, type, undefined);
      setPrincipalLoading(false);
      setIsDirty(false);
      setSolicitado(true);
    } catch (error) {
      setPrincipalLoading(false);
      errorHandler(error, 'Error al enviar la solicitud');
      setIsDirty(true);
    }
  };

  const uploadFile = async (file, type, setter, loading) => {
    try {
      loading(true);
      const reCaptchaToken = await executeRecaptcha('file/upload');
      const converted = await heicAndheifConvert(file.file);
      const compressedFile = await myImageCompression(
        converted,
        compressionOptions
      );
      const formData = new FormData();
      const { aseguradora } = cotizaciones.find(
        (item) => item.id === selectedCotizacion
      ).aseguradoraEmpresaProducto.aseguradoraEmpresa;
      const tokenCotizacionMPersona = cotizaciones.find(
        (item) => item.id === selectedCotizacion
      ).persona.token;
      formData.append('cedula', compressedFile);
      formData.append('reCaptchaToken', reCaptchaToken);
      formData.append('empresaId', empresa.id);
      formData.append('aseguradoraId', aseguradora.id);
      if (isMasiva && producto === 4) formData.append('isMasiva', isMasiva);
      formData.append(
        'cotizacionId',
        isMasiva && producto === 4
          ? tokenCotizacionMPersona
          : selectedCotizacion
      );

      if (type !== 'HAD' && type !== 'HAA') {
        const response = await instanceRef.instance.post(
          `file/upload?tipo=${type}`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        const fileData = response.data.data;
        switch (type) {
          case 'CIA': {
            validateCedulaIdentidad(fileData, 'CIA').then((isValid) => {
              if (!isEmpty(isValid)) {
                errorHandler(null, isValid);
                loading(false);
                setCedula1('');
              } else {
                loading(false);
                const fechaStr = fileData.fechaNacimiento;
                const fechaMoment = moment(fechaStr, 'DD/MM/YYYY');
                datosImg.fechaNacimiento = fechaStr;
                const { persona } = fileData;
                datosImg.nombres = fileData.nombresimg;
                datosImg.cedula = fileData.cedula;
                datosImg.score = fileData.scoreNombres;
                const tercero = {
                  nombres: fileData.razonSocial || fileData.nombres,
                  cedula: fileData.cedula,
                  ruc: fileData.ruc,
                  celular: fields.celular,
                  domicilio: fileData.persona ? fileData.persona.domicilio : '',
                  correo: fileData.persona ? fileData.persona.correo : ''
                };
                handleFormChange(fileData.nombres, 'nombres');
                handleFormChange(fileData.cedula, 'cedula');
                handleFormChange(fileData.ruc, 'ruc');
                handleFormChange(fileData.sexo, 'sexo');
                handleFormChange(fileData.lugarNacimiento, 'lugarNacimiento');
                handleFormChange(fields.celular, 'celular');
                if (fechaMoment.isValid()) {
                  handleFormChange(fechaMoment, 'fechaNacimiento');
                }
                handleFormChange(fileData.tipoDataBCP, 'personaBCP');
                if (fileData.tipoDataBCP) {
                  founddatosBCP.nombres = fileData.nombres;
                  founddatosBCP.cedula = fileData.cedula;
                  founddatosBCP.fechaNacimiento = fechaStr;
                  const newdatos = { ...datosBCP, ...founddatosBCP };
                  setDatosBCP(newdatos);
                }

                handleFormChange(tercero, 'tercero');
                let personaActualizada = {
                  ...persona,
                  ...fileData,
                  fechaNacimiento: fechaMoment.isValid() ? fechaMoment : null,
                  celular: fields.celular,
                  personaBCP: fileData.tipoDataBCP,
                  tercero
                };

                setDatosEncontrados({
                  ...datosEncontrados,
                  ...personaActualizada
                });
                const personaTransformada = transformarPropiedades({
                  ...personaActualizada
                });
                personaActualizada = {
                  ...personaActualizada,
                  ...personaTransformada
                };

                if (productoCotizacion.codigo === 4) {
                  setAsegurados({
                    list: [
                      {
                        nombres: personaActualizada.nombres || '',
                        cedula: personaActualizada.cedula,
                        tipo: 'titular',
                        fechaNacimiento: personaActualizada.fechaNacimiento,
                        personaBCP: fileData.tipoDataBCP,
                        moneda: selectedMonedaPlan
                      }
                    ]
                  });
                }
                const newdatos = { ...datosOriginales, ...datosImg };
                setDatosOriginales(newdatos);
                setDatosContactoFromCIA({ ...personaActualizada });

                const zonaUbicacion = {
                  departamentoInmueble: cotizaciones[0].id_departamento
                    ? `${cotizaciones[0].id_departamento}`
                    : undefined,
                  distritoInmueble: cotizaciones[0].id_distrito
                    ? `${cotizaciones[0].id_distrito}`
                    : undefined
                };
                const nuevosDatosContacto = {
                  ...datosContacto,
                  ...personaActualizada,
                  ...datosContactoFromCID,
                  ...zonaUbicacion
                };

                setDatosContacto({ ...nuevosDatosContacto });
                setDatosExternosPersona({
                  ...datosExternosPersona,
                  imagen: {
                    ...datosExternosPersona.imagen,
                    cedula: fileData.cedula,
                    nombres: fileData.nombresimg,
                    fechaNacimiento: fileData.fechasimg[0],
                    sexo: fileData.sexo
                  },
                  bcp: {
                    cedula: fileData.tipoDataBCP && fileData.cedula,
                    nombres: fileData.tipoDataBCP && fileData.nombresBcp,
                    fechaNacimiento: fileData.tipoDataBCP && fileData.fechasBcp
                  },
                  set: {
                    nombres: fileData.razonSocial,
                    ruc: fileData.ruc
                  },
                  sistemaCore: {
                    ...fileData.clienteExterno,
                    cedula: fileData.cedula,
                    nombres:
                      fileData.clienteExterno && fileData.clienteExterno.nombre,
                    fechaNacimiento:
                      fileData.clienteExterno &&
                      fileData.clienteExterno.fechaNacimiento,
                    sexo:
                      fileData.clienteExterno && fileData.clienteExterno.sexo,
                    estadoCivil:
                      fileData.clienteExterno &&
                      fileData.clienteExterno.estado_civil
                  }
                });
                getBase64(compressedFile, (imageUrl) => {
                  setter({
                    imagen: imageUrl,
                    extension: compressedFile.type.split('/')[1],
                    nombre: `${type}.${compressedFile.type.split('/')[1]}`
                  });
                });
                loading(false);
              }
            });
            break;
          }
          case 'CID': {
            validateCedulaIdentidad(fileData, 'CID').then((isValid) => {
              if (!isEmpty(isValid)) {
                errorHandler(null, isValid);
                loading(false);
                setCedula2('');
              } else {
                // Los datos de fileData son de la imagen de la cedula, los datos fileData.persona son datos de la BD
                const datosActualizados = {};

                const nacionalidad = fileData.persona
                  ? fileData.persona.nacionalidad
                  : fileData.nacionalidad;
                if (
                  nacionalidad &&
                  nacionalidad === NACIONALIDADES[0].descripcion
                ) {
                  handleFormChange(
                    NACIONALIDADES[0].descripcion,
                    'nacionalidad'
                  );
                  datosActualizados.descripcion = NACIONALIDADES[0].descripcion;
                } else {
                  handleFormChange(
                    NACIONALIDADES[1].descripcion,
                    'nacionalidad'
                  );
                  datosActualizados.nacionalidad =
                    NACIONALIDADES[1].descripcion;
                }

                let estadoCivil = fileData.persona
                  ? fileData.persona.estado_civil
                  : fileData.estadoCivil;
                const estado = ESTADOS.filter(({ descripcion }) => {
                  return descripcion === estadoCivil;
                });
                estadoCivil = estado[0] ? estado[0].descripcion : undefined;
                handleFormChange(estadoCivil, 'estadoCivil');
                datosActualizados.estado_civil = estadoCivil;

                setDatosEncontrados({
                  ...datosEncontrados,
                  ...datosActualizados
                });

                const personaActualizada = {
                  ...datosContacto,
                  nacionalidad,
                  estadoCivil
                };
                const nombres = fileData.nombres ? fileData.nombres : null;
                const cedula = fileData.nroDocumento
                  ? fileData.nroDocumento
                  : null;

                setDatosContactoFromCID({
                  ...personaActualizada,
                  nombres,
                  cedula
                });

                setDatosExternosPersonaImagenCID({
                  nacionalidad: fileData.nacionalidad,
                  estadoCivil: fileData.estadoCivil
                });

                getBase64(compressedFile, (imageUrl) => {
                  setter({
                    imagen: imageUrl,
                    extension: compressedFile.type.split('/')[1],
                    nombre: `${type}.${compressedFile.type.split('/')[1]}`
                  });
                });
                loading(false);
              }
            });
            break;
          }
          default: {
            break;
          }
        }
      }
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      loading(false);
    }
  };

  const validateStep = (step) => {
    switch (step.name) {
      case 'plan': {
        if (selectedPlan === null || selectedPlan === undefined) {
          message.warning('Debe seleccionar un plan');
          return false;
        }
        const { contado, fraccionado12 } = getSelectedPlan();
        const cantidadPagosSeleccionado =
          vigenciaPagosContext?.pagos?.cantidad_pagos;
        if (
          (cantidadPagosSeleccionado === 1 && contado === 0) ||
          (cantidadPagosSeleccionado > 1 && fraccionado12 === 0)
        ) {
          message.warning(
            `El plan no se encuentra disponible en la forma de pago seleccionada (${
              cantidadPagosSeleccionado === 1
                ? 'contado'
                : `${cantidadPagosSeleccionado} cuotas`
            })`
          );
          return false;
        }
        return true;
      }
      case 'fotos':
        if (!esJuridica && !soloNumCedula && (!cedula1 || !cedula2)) {
          message.warning('Debe cargar su cédula de identidad (ambos lados).');
          return false;
        }
        if (!esJuridica && !coincideCI && !soloNumCedula) {
          message.warning(
            'Su cédula de identidad frente/dorso deben coincidir'
          );
          return false;
        }
        if (soloNumCedula) {
          cedulaManualForm.validateFields();
          if (
            !cedulaManualForm.getFieldValue('cedula') ||
            !cedulaManualForm.getFieldValue('cedula').match(/^[0-9]{5,8}$/)
          ) {
            return false;
          }
        }
        return true;
      default:
        return false;
    }
  };

  const validarCedulaIdentidad = React.useCallback(async () => {
    try {
      const data = {
        datosCIA: {
          cedula: datosContactoFromCIA.cedula,
          nombres: datosContactoFromCIA.nombres
        },
        datosCID: {
          cedula: datosContactoFromCID.cedula,
          nombres: datosContactoFromCID.nombres
        }
      };
      const response = await instanceRef.instance.post(`file/validar`, data);
      let coincide = false;
      if (response.data?.data) {
        coincide = response.data?.data;
      }
      setCoincideCI(coincide);
      return coincide;
    } catch (error) {
      setCoincideCI(false);
      return null;
    }
  }, [
    datosContactoFromCIA.cedula,
    datosContactoFromCIA.nombres,
    datosContactoFromCID.cedula,
    datosContactoFromCID.nombres
  ]);

  const getVigenciaSugeridaAndConfig = React.useCallback(async () => {
    if (empresa && producto && token) {
      setLoadingVigenciaSugerida(true);
      try {
        const url =
          isMasiva && producto === 4
            ? `/cotizacionmasiva/vigencia-sugerida-config`
            : `/cotizacion/vigencia-sugerida-config`;
        const response = await instanceRef.instance.get(url, {
          params: {
            idEmpresa: empresa.id,
            idProducto: producto,
            token
          }
        });
        setVigenciaSugeridaConfig(response.data?.data);
      } catch (err) {
        errorHandler(err, 'Error al cargar la solicitud');
      }
      setLoadingVigenciaSugerida(false);
    }
  }, [empresa, producto, token, isMasiva]);

  useEffect(() => {
    getCotizacionActividadDetalles();
    getCotizacionActividades();
  }, []);

  useEffect(() => {
    if (cotizaciones && cotizaciones.length > 0 && screens.md !== undefined) {
      const { persona } = cotizaciones[0];
      setProductoCotizacion(cotizaciones[0].producto);
      handleFormChange(persona.nombres, 'nombres');
      handleFormChange(parseCelular(persona.celular), 'celular');
      if (!fields.correo) {
        handleFormChange(persona.correo, 'correo');
      }
      setSelectedCotizacion(undefined);
      setSelectedPlan(undefined);
      setSelectedMonedaPlan(undefined);
      setSelectedPlanTipo(undefined);
      setCurrent(0);
      const monedasConfiguradas = {};
      cotizaciones
        .flatMap((cotiz) => cotiz.planes)
        .forEach((item) => {
          monedasConfiguradas[item.moneda.codigo] = item.moneda;
        });

      const monedaGuaranies = Object.values(monedasConfiguradas).find(
        (item) => item.codigo === 'gs'
      );
      if (!moneda) {
        if (monedaGuaranies) {
          setMoneda(monedaGuaranies);
        } else {
          const codigoPrimeraMoneda = Object.keys(monedasConfiguradas)[0];
          setMoneda(monedasConfiguradas[codigoPrimeraMoneda]);
        }
      }
      setMonedas(Object.values(monedasConfiguradas));
    }
  }, [cotizaciones, moneda]);

  useEffect(() => {
    if (cedula1 && cedula2) {
      validarCedulaIdentidad();
    }
  }, [cedula1, cedula2, validarCedulaIdentidad]);

  useEffect(() => {
    if (empresa && producto && token) {
      getVigenciaSugeridaAndConfig();
    }
  }, [empresa, getVigenciaSugeridaAndConfig, producto, token]);

  const handleFormChange = (value, field) => {
    setFields((fieldsParam) => {
      return { ...fieldsParam, [field]: value };
    });
  };

  const eventListener = (event) => {
    if (isDirty) {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      // eslint-disable-next-line no-param-reassign
      event.returnValue =
        'Es posible que los cambios que implementaste no se puedan guardar';
    }
  };

  const cedulaAdelanteUpload = () => (
    <div>
      <Upload
        style={{ width: 'auto !important' }}
        name="avatarAdelante"
        accept={formatosImagen}
        listType="picture-card"
        className={`avatar-uploader ${cedula1 ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) => uploadFile(e, 'CIA', setCedula1, setLoading1)}
        beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
        disabled={loading1}
      >
        <>
          {loading1 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading1 && (
            <>
              {cedula1 ? (
                <img
                  src={cedula1.imagen}
                  alt="avatarAdelante"
                  className="upload-img"
                />
              ) : (
                <div className="upload-img-wrapper">
                  <PlusOutlined />
                  <div className="ant-upload-text">(Frente)</div>
                  <img
                    src="/images/cedula_adelante.png"
                    alt="avatar"
                    style={{ width: '100%' }}
                  />
                </div>
              )}
            </>
          )}
        </>
      </Upload>
    </div>
  );

  const cedulaAtrasUpload = () => (
    <div>
      <Upload
        style={{ width: 'auto !important' }}
        name="avatarAtras"
        accept={formatosImagen}
        listType="picture-card"
        className={`avatar-uploader ${cedula2 ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) => uploadFile(e, 'CID', setCedula2, setLoading2)}
        beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
        disabled={loading2}
      >
        <>
          {loading2 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading2 && (
            <>
              {cedula2 ? (
                <img
                  src={cedula2.imagen}
                  alt="avatarAtras"
                  className="upload-img"
                />
              ) : (
                <div className="upload-img-wrapper">
                  <PlusOutlined />
                  <div className="ant-upload-text">(Dorso)</div>
                  <img
                    src="/images/cedula_atras.png"
                    alt="avatar"
                    style={{ width: '100%' }}
                  />
                </div>
              )}
            </>
          )}
        </>
      </Upload>
    </div>
  );

  useEffect(() => {
    window.addEventListener('beforeunload', eventListener);
    return function cleanup() {
      window.removeEventListener('beforeunload', eventListener);
    };
  });

  const { descripcion } = productoCotizacion;
  let titulo = '';
  if (descripcion) {
    titulo =
      current === 0
        ? `Cotización de Seguro - ${descripcion}`
        : `Solicitá tu Seguro - ${descripcion}`;
  }
  // todas las cotizaciones de un mismo token tienen el mismo tipo de venta, seleccionamos la primera pero podria ser cualquiera
  const tipoVenta = cotizaciones ? cotizaciones[0]?.tipo_venta : null;
  const baseURL = CONFIG.URL_BASE;

  const todasCotizacionesPendienteAutorizacion = cotizaciones?.every(
    (item) => item?.autorizacionFlujo[0]?.estado === 'PENDIENTE'
  );
  // tomamos el tipo de venta de la primera cotizacion ya que todas las cotizaciones de un mismo toke deberian tener el mismo tipo de venta
  const isCotizacionesPresencial =
    cotizaciones && cotizaciones.length > 0
      ? cotizaciones[0].tipo_venta === 'presencial'
      : false;
  const handlePrintClick = (e) => {
    let url;
    switch (e.key) {
      case 'cotizacion':
        url = `${baseURL}/cotizacion/info-pdf?token=${token}&cantidad_pagos=${
          vigenciaPagosContext?.pagos?.cantidad_pagos
        }&cantidad_dias=${
          vigenciaPagosContext?.cantidad_dias
        }&desde=${vigenciaPagosContext?.desde.format()}&hasta=${vigenciaPagosContext?.hasta.format()}&tipo=cotizacion`;
        window.open(url, '_blank');
        break;
      case 'propuestas':
        url = `${baseURL}/cotizacion/info-pdf?token=${token}&cantidad_pagos=${
          vigenciaPagosContext?.pagos?.cantidad_pagos
        }&cantidad_dias=${
          vigenciaPagosContext?.cantidad_dias
        }&desde=${vigenciaPagosContext?.desde.format()}&hasta=${vigenciaPagosContext?.hasta.format()}&tipo=propuestas`;
        window.open(url, '_blank');
        break;
      default:
    }
  };
  const items = [
    {
      label: 'Cotización',
      key: 'cotizacion'
    },
    {
      label: 'Propuestas',
      key: 'propuestas'
    }
  ];
  const dropDownProps = {
    items,
    onClick: handlePrintClick
  };

  steps =
    empresaProducto?.beneficiarios || producto === 5
      ? steps
      : steps.slice(0, 3).concat(steps.slice(4));

  const getCliente = async (cedula) => {
    try {
      setLoadingBefore(true);
      const { aseguradora } = cotizaciones.find(
        (item) => item.id === selectedCotizacion
      ).aseguradoraEmpresaProducto.aseguradoraEmpresa;
      const datos = await consultarCliente(
        aseguradora.id,
        cedula,
        selectedCotizacion
      );
      setLoadingBefore(false);
      return datos;
    } catch (e) {
      message.error(e.message);
      setLoadingBefore(false);
      return null;
    }
  };

  const settearDatosCliente = (datos) => {
    const { persona } = datos;
    const tercero = {
      nombres: datos.razonSocial || datos.nombres,
      cedula: datos.cedula,
      ruc: datos.ruc,
      celular: fields.celular,
      domicilio: datos.persona ? datos.persona.domicilio : '',
      correo: datos.persona ? datos.persona.correo : ''
    };
    handleFormChange(datos.nombres, 'nombres');
    handleFormChange(datos.cedula, 'cedula');
    handleFormChange(datos.ruc, 'ruc');
    handleFormChange(datos.sexo, 'sexo');
    handleFormChange(datos.lugarNacimiento, 'lugarNacimiento');
    handleFormChange(fields.celular, 'celular');
    handleFormChange(datos.tipoDataBCP, 'personaBCP');
    if (datos.tipoDataBCP) {
      founddatosBCP.nombres = datos.nombres;
      founddatosBCP.cedula = datos.cedula;
      const newdatos = { ...datosBCP, ...founddatosBCP };
      setDatosBCP(newdatos);
    }

    handleFormChange(tercero, 'tercero');
    let personaActualizada = {
      ...persona,
      ...datos,
      celular: fields.celular,
      personaBCP: datos.tipoDataBCP,
      tercero
    };

    setDatosEncontrados({
      ...datosEncontrados,
      ...personaActualizada
    });
    const personaTransformada = transformarPropiedades({
      ...personaActualizada
    });
    personaActualizada = {
      ...personaActualizada,
      ...personaTransformada
    };

    if (productoCotizacion.codigo === 4) {
      setAsegurados({
        list: [
          {
            nombres: personaActualizada.nombres || '',
            cedula: personaActualizada.cedula,
            tipo: 'titular',
            fechaNacimiento: personaActualizada.fechaNacimiento,
            personaBCP: datos.tipoDataBCP,
            moneda: selectedMonedaPlan
          }
        ]
      });
    }
    const newdatos = { ...datosOriginales, ...datosImg };
    setDatosOriginales(newdatos);
    setDatosContactoFromCIA({ ...personaActualizada });

    const zonaUbicacion = {
      departamentoInmueble: cotizaciones[0].id_departamento
        ? `${cotizaciones[0].id_departamento}`
        : undefined,
      distritoInmueble: cotizaciones[0].id_distrito
        ? `${cotizaciones[0].id_distrito}`
        : undefined
    };
    const nuevosDatosContacto = {
      ...datosContacto,
      ...personaActualizada,
      ...datosContactoFromCID,
      ...zonaUbicacion
    };

    setDatosContacto({ ...nuevosDatosContacto });
    setDatosExternosPersona({
      ...datosExternosPersona,
      imagen: {
        ...datosExternosPersona.imagen,
        cedula: datos.cedula,
        nombres: datos.nombresimg,
        sexo: datos.sexo
      },
      bcp: {
        cedula: datos.tipoDataBCP && datos.cedula,
        nombres: datos.tipoDataBCP && datos.nombresBcp,
        fechaNacimiento: datos.tipoDataBCP && datos.fechasBcp
      },
      set: {
        nombres: datos.razonSocial,
        ruc: datos.ruc
      },
      sistemaCore: {
        ...datos.clienteExterno,
        cedula: datos.cedula,
        nombres: datos.clienteExterno && datos.clienteExterno.nombre,
        fechaNacimiento:
          datos.clienteExterno && datos.clienteExterno.fechaNacimiento,
        sexo: datos.clienteExterno && datos.clienteExterno.sexo,
        estadoCivil: datos.clienteExterno && datos.clienteExterno.estado_civil
      }
    });
  };

  const getDatosCliente = async () => {
    const datos = await getCliente(cedulaManualForm.getFieldValue('cedula'));
    settearDatosCliente(datos);
    setCurrent(current + 1);
    setTimeout(() => scrollTop());
  };

  return (
    <>
      <ResponsiveContainer
        size={current !== 0 ? 'large' : undefined}
        style={{ maxWidth: current === 0 && maxWidthHoja }}
      >
        <Card style={{ borderRadius: 4 }}>
          <div ref={myRef} />
          <div style={{ display: 'flex' }}>
            {isCotizacionesPresencial && current === 0 && (
              <div style={{ width: '20%' }} />
            )}
            {!solicitado && current !== steps.length - 1 && (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Title>{titulo}</Title>
                </div>
              </>
            )}
            {isCotizacionesPresencial && current === 0 && (
              <div
                style={{
                  width: '20%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Dropdown
                  menu={dropDownProps}
                  trigger={['click']}
                  disabled={todasCotizacionesPendienteAutorizacion}
                >
                  <Tooltip
                    title={
                      todasCotizacionesPendienteAutorizacion
                        ? 'No hay cotizaciones autorizadas para imprimir.'
                        : 'Imprimir'
                    }
                  >
                    <Button
                      type="primary"
                      size="large"
                      disabled={todasCotizacionesPendienteAutorizacion}
                    >
                      <Space>
                        <PrinterOutlined style={{ fontSize: '25px' }} />
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Tooltip>
                </Dropdown>
              </div>
            )}
          </div>
          {!solicitado && current !== steps.length - 1 && !empresa.tiene_sms && (
            <>
              <br />
              <Badge
                status="warning"
                text="El enlace para acceder nuevamente a esta página ha sido enviado a su correo electrónico."
              />
            </>
          )}
          {(solicitado && smsEnviado && (
            <Result
              status="success"
              title="¡SMS con Link para Aprobación/Firma enviado exitosamente!"
              subTitle=""
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  Ir al inicio
                </Button>
              ]}
            />
          )) || (
            <>
              <div>
                {current > 0 && current !== steps.length - 1 && (
                  <StepperSolicitud
                    current={current}
                    steps={steps.slice(0, 6)}
                  />
                )}
              </div>
              {current > 0 && current === steps.length - 1 && (
                <Title>
                  {solicitado && '¡Solicitud enviada!'}
                  {!solicitado && steps[current].description}
                </Title>
              )}
              {current > 0 && current !== steps.length - 1 && (
                <div>
                  <br />
                  <Subtitle>
                    {steps[current].description}
                    {current === 2 &&
                      incluyeOtros &&
                      ' (Opcional: Agregar Asegurados Adicionales)'}
                    {(steps[current].name === 'asegurados' ||
                      steps[current].name === 'beneficiarios') &&
                      ' para cobertura de Accidentes Personales'}
                  </Subtitle>
                  <br />
                </div>
              )}
              {steps[current].name === 'plan' && (
                <div
                  style={{
                    marginLeft: marginLeftPrincipal,
                    marginRight: marginRightPrincipal
                  }}
                >
                  <SolicitudPlanVigencia
                    loaded={!loadedPlanes}
                    debouncing={debouncing}
                    onDebounce={onDebounce}
                    planSelectorData={{
                      cotizaciones,
                      setSelectedPlan,
                      setSelectedCotizacion,
                      selectedCotizacion,
                      selectedPlan,
                      selectedPlanTipo,
                      setSelectedPlanTipo,
                      selectedMonedaPlan,
                      setSelectedMonedaPlan,
                      loading: loadingPlanes
                    }}
                    opcionesDePago={{
                      numeroCuotas: vigenciaPagosContext?.pagos?.cantidad_pagos
                    }}
                    {...{
                      vigenciaByAseguradoraList,
                      setVigenciaByAseguradoraList
                    }}
                    moneda={moneda}
                    monedas={monedas}
                    setMoneda={setMoneda}
                    vigenciaSugeridaConfig={vigenciaSugeridaConfig}
                    loading={loadingVigenciaSugerida}
                    margintLeftPrincipal={-marginLeftPrincipal}
                    datosExtra={() => (
                      <>
                        {((user && user['cognito:groups'][0] === 'CLIENTE') ||
                          (!user &&
                            (userState === USER_STATES.loggingEnd ||
                              userState === USER_STATES.notLogged))) && (
                          <>
                            <div
                              style={{
                                maxWidth,
                                margin: 'auto',
                                marginBottom: 20
                              }}
                            >
                              <div
                                style={{
                                  textAlign: 'left',
                                  paddingTop: 20,
                                  paddingBottom: 8
                                }}
                              >
                                <strong>
                                  Estimado Sr/Sra
                                  {` ${
                                    cotizaciones?.[0]?.persona?.nombres || ''
                                  }`}{' '}
                                </strong>
                              </div>
                              <Typography.Paragraph
                                level={5}
                                style={{ textAlign: 'left' }}
                              >
                                {`A continuación encontrará la cotización para su seguro de ${
                                  descripcion || ''
                                } y los principales
              detalles de la misma.`}
                              </Typography.Paragraph>
                            </div>
                          </>
                        )}
                        {user && user['cognito:groups'][0] !== 'CLIENTE' && (
                          <div
                            style={{
                              maxWidth,
                              margin: 'auto',
                              marginBottom: 20
                            }}
                          >
                            <TitleBar>
                              <>
                                {screens && screens.md === true && (
                                  <SubSubtitleStart
                                    level={5}
                                    style={{
                                      fontWeight: '500'
                                    }}
                                  >
                                    Datos de Contacto
                                  </SubSubtitleStart>
                                )}
                                {screens && screens.md === false && (
                                  <SubSubtitle
                                    level={5}
                                    style={{
                                      fontWeight: '500'
                                    }}
                                  >
                                    Datos de Contacto
                                  </SubSubtitle>
                                )}
                              </>
                            </TitleBar>

                            <Descriptions
                              bordered
                              size="small"
                              style={{ textAlign: 'left' }}
                              labelStyle={{ width: '20%' }}
                              contentStyle={{ width: '30%' }}
                              column={{ md: 2, sm: 1, xs: 1 }}
                            >
                              <Descriptions.Item label="Nombre" span={2}>
                                {cotizaciones?.[0]?.persona?.nombres}
                              </Descriptions.Item>
                              <Descriptions.Item label="Nro. de Teléfono">
                                {cotizaciones?.[0]?.persona?.celular}
                              </Descriptions.Item>
                              <Descriptions.Item label="E-mail">
                                {cotizaciones?.[0]?.persona?.correo || 'N/A'}
                              </Descriptions.Item>
                            </Descriptions>

                            <TitleBar>
                              <>
                                {screens && screens.md === true && (
                                  <SubSubtitleStart
                                    level={5}
                                    style={{
                                      fontWeight: '500'
                                    }}
                                  >
                                    Datos básicos de la ubicación
                                  </SubSubtitleStart>
                                )}
                                {screens && screens.md === false && (
                                  <SubSubtitle
                                    level={5}
                                    style={{
                                      fontWeight: '500'
                                    }}
                                  >
                                    Datos básicos de la ubicación
                                  </SubSubtitle>
                                )}
                              </>
                            </TitleBar>

                            <Descriptions
                              bordered
                              size="small"
                              style={{ textAlign: 'left' }}
                              labelStyle={{ width: '20%' }}
                              contentStyle={{ width: '30%' }}
                              column={{ md: 2, sm: 1, xs: 1 }}
                            >
                              <Descriptions.Item label="Departamento">
                                {cotizaciones?.[0]?.departamento?.descripcion ||
                                  'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Ciudad">
                                {cotizaciones?.[0]?.distrito?.descripcion ||
                                  'N/A'}
                              </Descriptions.Item>
                            </Descriptions>
                          </div>
                        )}
                      </>
                    )}
                  />
                </div>
              )}

              {steps[current].name === 'fotos' && (
                <>
                  <Spin spinning={loadingBefore} delay={500} size="large">
                    <Row gutter={[16, 0]} justify="center">
                      <Col xs={24} md={24}>
                        <Label>
                          {' '}
                          ¿La póliza/factura deben ser emitidas a nombre de una
                          Persona Jurídica?{' '}
                          <Switch
                            checked={esJuridica}
                            onChange={() => {
                              setEsJuridica(!esJuridica);
                            }}
                          />
                        </Label>
                      </Col>
                    </Row>
                    {tipoVenta === 'presencial' &&
                      noEsCliente &&
                      !empresa.requiere_cedula && (
                        <Row gutter={[16, 0]} justify="center">
                          <Col xs={24} md={24}>
                            <Label>
                              {' '}
                              ¿Prefieres ingresar solamente el número de cédula?{' '}
                              <Switch
                                checked={soloNumCedula}
                                onChange={() => {
                                  setSoloNumCedula(!soloNumCedula);
                                }}
                              />
                            </Label>
                          </Col>
                        </Row>
                      )}
                    {!esJuridica && !soloNumCedula && (
                      <Row
                        gutter={[16, 0]}
                        justify="center"
                        style={{ textAlign: 'start' }}
                      >
                        {screens.md && (
                          <>
                            <Col
                              xs={4}
                              style={{
                                ...colStyles,
                                marginTop: '50px'
                              }}
                            >
                              {cedulaAdelanteUpload()}
                            </Col>
                            <Col
                              xs={4}
                              style={{
                                ...colStyles,
                                marginTop: '50px'
                              }}
                            >
                              {cedulaAtrasUpload()}
                            </Col>
                          </>
                        )}
                        {screens.md === false && (
                          <>
                            <Col
                              xs={24}
                              style={{
                                ...colStyles,
                                marginTop: '50px'
                              }}
                            >
                              {cedulaAdelanteUpload()}
                            </Col>
                            <Col xs={24} style={colStyles}>
                              {cedulaAtrasUpload()}
                            </Col>
                          </>
                        )}
                      </Row>
                    )}
                    {soloNumCedula && (
                      <Row gutter={[16, 0]} justify="center">
                        <Col
                          xs={24}
                          md={12}
                          lg={6}
                          align="start"
                          style={{
                            ...colStyles,
                            marginTop: '50px'
                          }}
                        >
                          <Form
                            scrollToFirstError
                            form={cedulaManualForm}
                            name="cedulaManualForm"
                            autoComplete="off"
                            layout="horizontal"
                          >
                            <Form.Item
                              label="Cédula de Identidad"
                              name="cedula"
                              rules={[
                                { required: true, message: 'Requerido' },
                                {
                                  pattern: '^[0-9]{5,8}$',
                                  message: 'Verificar formato. Ej.: 12345678'
                                }
                              ]}
                              style={{ textAlign: 'left' }}
                            >
                              <Input />
                            </Form.Item>
                          </Form>
                        </Col>
                      </Row>
                    )}
                  </Spin>
                </>
              )}

              {steps[current].name === 'asegurados' && (
                <>
                  <AseguradosList
                    plan={selectedMonedaPlan && getSelectedPlan()}
                    cotizacion={cotizaciones.find(
                      (item) => item.id === selectedCotizacion
                    )}
                    defaultList={asegurados}
                    onBack={(values) => {
                      setAsegurados(values);
                      setCurrent(current - 1);
                    }}
                    onNext={(values) => {
                      setCurrent(current + 1);
                      const newValues = lodashClonedeep(values);
                      const newValues2 = lodashClonedeep(values);
                      newValues2.list[0].fechaNacimiento = moment(
                        values.list[0].fechaNacimiento
                      ).format('DD-MM-YYYY');

                      setAsegurados(newValues);

                      const conyuges = values.list.filter(
                        (item) => item.tipo === 'conyuge'
                      );
                      const listaBeneficiarios = conyuges.map(
                        ({ nombres, tipo: relacion }) => ({
                          nombres,
                          relacion,
                          beneficio: 100 / conyuges.length
                        })
                      );
                      if (listaBeneficiarios.length > 0) {
                        setBeneficiarios({
                          list: listaBeneficiarios
                        });
                      } else {
                        setBeneficiarios({
                          list: [
                            {
                              beneficio: 100
                            }
                          ]
                        });
                      }

                      const nuevosDatosContacto = {
                        ...datosContacto,
                        ...datosContactoFromCIA,
                        ...datosContactoFromCID
                      };

                      let aseguradoActualizado = values.list.filter(
                        (item) => item.tipo === 'titular'
                      )[0];

                      aseguradoActualizado = {
                        ...aseguradoActualizado,
                        tercero: {
                          ...nuevosDatosContacto.tercero,
                          cedula: !esJuridica
                            ? nuevosDatosContacto.tercero.cedula
                            : '',
                          nombres: !esJuridica
                            ? nuevosDatosContacto.tercero.nombres
                            : ''
                        }
                      };

                      setDatosContacto({
                        ...nuevosDatosContacto,
                        ...aseguradoActualizado,
                        rubro: [...cotizacionActividadDetalles],
                        tipo_establecimiento: [...cotizacionActividades]
                      });

                      setTimeout(() => {
                        scrollTop();
                      });
                    }}
                  />
                </>
              )}
              {steps[current].name === 'beneficiarios' && (
                <>
                  <BeneficiariosList
                    defaultList={beneficiarios}
                    onBack={(values) => {
                      setBeneficiarios(values);
                      setCurrent(current - 1);
                    }}
                    onNext={(values) => {
                      setCurrent(current + 1);
                      setBeneficiarios(values);
                      setTimeout(() => scrollTop());
                    }}
                  />
                </>
              )}
              {steps[current].name === 'contacto' && vigenciaSugeridaConfig && (
                <ContactoHogar
                  handleFormChange={handleFormChange}
                  esJuridica={esJuridica}
                  datosOriginales={datosOriginales}
                  cuestionario={productoCotizacion.cuestionario}
                  listaMetodoPago={cotizaciones
                    .find((item) => item.id === selectedCotizacion)
                    .aseguradoraEmpresaProducto.empresaProductoMetodo.map(
                      ({ metodoPago }) => metodoPago
                    )}
                  listaModalidadPago={cotizaciones
                    .find((item) => item.id === selectedCotizacion)
                    .aseguradoraEmpresaProducto.empresaProductoModalidad.map(
                      ({ modalidadPago }) => modalidadPago
                    )}
                  listaVigenciaPago={cotizaciones
                    .find((item) => item.id === selectedCotizacion)
                    .aseguradoraEmpresaProducto.empresaProductoVigencia.map(
                      ({ vigenciaPago }) => vigenciaPago
                    )}
                  defaultValue={datosContacto}
                  titular={asegurados.list?.find(
                    (item) => item.tipo === 'titular'
                  )}
                  aseguradora={
                    cotizaciones.find((item) => item.id === selectedCotizacion)
                      .aseguradoraEmpresaProducto.aseguradoraEmpresa.aseguradora
                  }
                  onBack={(values, encontrados, encontradosEmpresaJuridica) => {
                    setDatosContacto(values);
                    if (encontrados) {
                      setDatosEncontrados({
                        ...datosEncontrados,
                        ...encontrados
                      });
                    }
                    if (encontradosEmpresaJuridica) {
                      setDatosEncontradosEmpresaJuridica({
                        ...datosEncontradoEmpresaJuridica,
                        ...encontradosEmpresaJuridica
                      });
                    }
                    setCurrent(current - 1);
                  }}
                  onNext={(values, encontrados, encontradosEmpresaJuridica) => {
                    // if (values.cedulaOrRuc.includes('-')) {
                    //   values.ruc = values.cedulaOrRuc;
                    // }
                    setDatosContacto(values);
                    if (encontrados) {
                      setDatosEncontrados({
                        ...datosEncontrados,
                        ...encontrados
                      });
                    }
                    if (encontradosEmpresaJuridica) {
                      setDatosEncontradosEmpresaJuridica({
                        ...datosEncontradoEmpresaJuridica,
                        ...encontradosEmpresaJuridica
                      });
                    }
                    const aseguradoActualizado = {
                      list: asegurados.list?.map((item) => ({
                        ...item,
                        nombres: values.nombres
                      }))
                    };
                    setAsegurados({ ...aseguradoActualizado });
                    setTimeout(() => {
                      setCurrent(current + 1);
                      scrollTop();
                    });
                  }}
                  plan={selectedMonedaPlan && getSelectedPlan()}
                  moneda={moneda}
                  vigenciaSugeridaConfig={vigenciaSugeridaConfig}
                  loading={loadingPlanes}
                  {...{ construccionData, setConstruccionData }}
                />
              )}
              {steps[current].name === 'confirmar' && (
                <Spin
                  spinning={principalLoading}
                  delay={500}
                  size="large"
                  tip="Procesando la información ingresada. Aguarde un momento."
                  style={{
                    position: 'fixed',
                    left: marginLeft,
                    right: 0,
                    transform: `translate(calc(50vw - 50%), calc(50vh - 50%))`
                  }}
                >
                  <DescripcionesHogar
                    {...{
                      plan: getCarouselData(
                        getTable(
                          cotizaciones
                            .find((item) => item.id === selectedCotizacion)
                            .planes.filter(
                              (item) =>
                                item.id_moneda === selectedMonedaPlan.id &&
                                ((item.id_plan &&
                                  selectedPlanTipo === 'estandar') ||
                                  (!item.id_plan &&
                                    selectedPlanTipo === 'especifico'))
                            ),
                          null,
                          null,
                          producto,
                          null,
                          true,
                          undefined,
                          false,
                          selectedMonedaPlan
                        )
                      )[selectedPlan],
                      listaMetodoPago: cotizaciones
                        .find((item) => item.id === selectedCotizacion)
                        .aseguradoraEmpresaProducto.empresaProductoMetodo.map(
                          ({ metodoPago }) => metodoPago
                        ),
                      listaVigenciaPago: cotizaciones
                        .find((item) => item.id === selectedCotizacion)
                        .aseguradoraEmpresaProducto.empresaProductoVigencia.map(
                          ({ vigenciaPago }) => vigenciaPago
                        ),
                      asegurados,
                      relacionesAsegurados,
                      beneficiarios,
                      relaciones,
                      contacto: datosContacto,
                      cuestionario: productoCotizacion.cuestionario,
                      aseguradora: cotizaciones.find(
                        (item) => item.id === selectedCotizacion
                      ).aseguradoraEmpresaProducto.aseguradoraEmpresa
                        .aseguradora,
                      listaModalidadPago: cotizaciones
                        .find((item) => item.id === selectedCotizacion)
                        .aseguradoraEmpresaProducto.empresaProductoModalidad.map(
                          ({ modalidadPago }) => modalidadPago
                        ),
                      esJuridica,
                      vigencia: vigenciaPagosContext,
                      pagos: vigenciaPagosContext && vigenciaPagosContext.pagos,
                      calendarioList: calendarioPagosContext,
                      construccion: construccionData
                    }}
                  />
                </Spin>
              )}
              <div className="steps-action">
                {current === steps.length - 1 &&
                  !solicitado &&
                  empresaProducto &&
                  empresaProducto.poliza_impresion && (
                    <Row
                      gutter={[16, 0]}
                      style={{
                        maxWidth,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    >
                      <Col xs={24} md={12} align="start">
                        <div style={{ marginBottom: '5px' }}>
                          <span>¿Desea póliza impresa?</span>
                        </div>
                        <Switch
                          checked={impresion}
                          onChange={(value) => setImpresion(!!value)}
                        />
                      </Col>
                    </Row>
                  )}
                {current > 0 &&
                  steps[current].name !== 'asegurados' &&
                  steps[current].name !== 'beneficiarios' &&
                  steps[current].name !== 'contacto' &&
                  !solicitado && (
                    <Button
                      style={{ margin: 10 }}
                      onClick={() => setCurrent(current - 1)}
                      disabled={principalLoading}
                    >
                      Anterior
                    </Button>
                  )}
                {(steps[current].name === 'plan' ||
                  steps[current].name === 'fotos' ||
                  steps[current].name === 'solicitar') &&
                  descripcion && (
                    <Button
                      disabled={loading1 || loading2}
                      type="primary"
                      style={{ margin: 10 }}
                      onClick={() => {
                        if (validateStep(steps[current])) {
                          if (
                            steps[current].name === 'fotos' &&
                            soloNumCedula
                          ) {
                            getDatosCliente();
                          } else {
                            setCurrent(current + 1);
                            setTimeout(() => scrollTop());
                          }
                        }
                      }}
                    >
                      {current === 0 ? 'Solicitar' : 'Siguiente'}
                    </Button>
                  )}
                {current === steps.length - 1 && !solicitado && (
                  <BotonSiguiente
                    tipoVenta={tipoVenta}
                    solicitar={solicitar}
                    principalLoading={principalLoading}
                    datosOriginales={datosOriginales}
                    token={token}
                    noEsCliente={noEsCliente}
                  />
                )}
              </div>
            </>
          )}
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default FormNew;
